import Vue  from 'vue';
import Vuex from 'vuex';
import ua from './modules/ua';
import path from './modules/path';
import config from './modules/config';
import navigation from './modules/navigation';
import links from './modules/links';
import status from './modules/status';
import notices from './modules/notices';
import mq from './modules/mq';
import ls from './modules/ls';
import lsFactory from './modules/ls/factory';
import browser from './modules/browser';
import segments from './modules/segments';
import selfcheck from './modules/selfcheck';
import selfcheckFactory from './modules/selfcheck/selfcheck-factory';



Vue.use(Vuex);



const registerdModuleNames = [];

const store = new Vuex.Store({
  strict: IS_DEVELOP,

  state: {
    registerdNamedLs: [],
  },

  modules: {
    ua,
    path,
    config,
    navigation,
    links,
    status,
    notices,
    mq,
    ls,
    browser,
    segments,
    selfcheck,
  },

  getters: {
    registerdNamedLs: state => state.registerdNamedLs,
  },

  actions: {
    useLsByPrefix: async ({ commit, dispatch, rootGetters }, prefix) => {
      if (prefix === rootGetters['config/year']) return;

      const moduleName = `ls-${prefix}`;
      if (registerdModuleNames.includes(moduleName)) return;
      registerdModuleNames.push(moduleName);
      store.registerModule(moduleName, lsFactory(prefix));
      await dispatch(`${moduleName}/init`);
      commit('pushRegisterdNamedLs', prefix);
    },

    loadSelfcheck: ({ getters, dispatch }, year = getters['config/year']) => {
      const moduleName = `selfcheck-${year}`;
      if (registerdModuleNames.includes(moduleName)) return;
      registerdModuleNames.push(moduleName);
      store.registerModule(moduleName, selfcheckFactory(year));
      return dispatch(`${moduleName}/load`);
    },
  },

  mutations: {
    pushRegisterdNamedLs: (state, prefix) => {
      if (!state.registerdNamedLs.includes(prefix)) state.registerdNamedLs.push(prefix);
    },
  },
});

store.dispatch('config/load');
store.dispatch('links/load');
store.dispatch('navigation/load');
store.dispatch('status/load');
store.dispatch('notices/load');
store.dispatch('mq/start');
store.dispatch('ls/init');
store.dispatch('browser/init');

export default store;


// WEBPACK FOOTER //
// ./src/js/store/index.js